import { DefinedValue, RealDefinedValue } from "@Alternatives/Model";
import { ICommandBase } from "@Alternatives/cqrs";

export class CreateNumericAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Attributes.Commands.CreateNumericAttributeCommandV1, TCh.Domain.Alternatives';

	IsCorporate: boolean;

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;

	InternalName: string | null;
	Name: string;
	Description: string;
	Section: string;
	InputType: string;
	AllowMultipleValues: boolean;

	MinValue: number | null;
	MaxValue: number | null;
	Script: string | null;
	DefinedValues: RealDefinedValue[] | null;

	constructor(isCorporate: boolean, workspaceId: number, projectId: number, alternativesListId: number, attributeId: number, internalName: string | null, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minValue: number | null, maxValue: number | null, script: string | null, definedValues: RealDefinedValue[] | null)
	{
		this.IsCorporate = isCorporate;

		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = attributeId.toString();

		this.InternalName = internalName;
		this.Name = name;
		this.Description = description;
		this.Section = section;
		this.InputType = inputType;
		this.AllowMultipleValues = allowMultipleValues;

		this.MinValue = minValue;
		this.MaxValue = maxValue;
		this.Script = script;
		this.DefinedValues = definedValues;		
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Attributes.Commands.CreateNumericAttributeCommandV1, TCh.Domain.Alternatives';
	}
}
export class CreateDateAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Attributes.Commands.CreateDateAttributeCommandV1, TCh.Domain.Alternatives';

	IsCorporate: boolean;

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;

	InternalName: string | null;
	Name: string;
	Description: string;
	Section: string;
	InputType: string;
	AllowMultipleValues: boolean;

	MinValue: Date | null;
	MaxValue: Date | null;
	DefinedValues: DefinedValue[] | null;

	constructor(isCorporate: boolean, workspaceId: number, projectId: number, alternativesListId: number, attributeId: number, internalName: string | null, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minValue: Date | null, maxValue: Date | null, definedValues: DefinedValue[] | null)
	{
		this.IsCorporate = isCorporate;

		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = attributeId.toString();

		this.InternalName = internalName;
		this.Name = name;
		this.Description = description;
		this.Section = section;
		this.InputType = inputType;
		this.AllowMultipleValues = allowMultipleValues;

		this.MinValue = minValue;
		this.MaxValue = maxValue;
		this.DefinedValues = definedValues;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Attributes.Commands.CreateDateAttributeCommandV1, TCh.Domain.Alternatives';
	}
}
export class CreateTextAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Attributes.Commands.CreateTextAttributeCommandV1, TCh.Domain.Alternatives';

	IsCorporate: boolean;

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;

	InternalName: string | null;
	Name: string;
	Description: string;
	Section: string;
	InputType: string;
	AllowMultipleValues: boolean;

	MinLength: number | null;
	MaxLength: number | null;
	DefinedValues: DefinedValue[] | null;

	constructor(isCorporate: boolean, workspaceId: number, projectId: number, alternativesListId: number, attributeId: number, internalName: string | null, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minLength: number | null, maxLength: number | null, definedValues: DefinedValue[] | null)
	{
		this.IsCorporate = isCorporate;

		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = attributeId.toString();

		this.InternalName = internalName;
		this.Name = name;
		this.Description = description;
		this.Section = section;
		this.InputType = inputType;
		this.AllowMultipleValues = allowMultipleValues;

		this.MinLength = minLength;
		this.MaxLength = maxLength;
		this.DefinedValues = definedValues;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Attributes.Commands.CreateTextAttributeCommandV1, TCh.Domain.Alternatives';
	}
}
export class CreateEmailAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Attributes.Commands.CreateEmailAttributeCommandV1, TCh.Domain.Alternatives';

	IsCorporate: boolean;

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;

	InternalName: string | null;
	Name: string;
	Description: string;
	Section: string;
	InputType: string;
	AllowMultipleValues: boolean;

	DefinedValues: DefinedValue[] | null;

	constructor(isCorporate: boolean, workspaceId: number, projectId: number, alternativesListId: number, attributeId: number, internalName: string | null, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean, definedValues: DefinedValue[] | null)
	{
		this.IsCorporate = isCorporate;

		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = attributeId.toString();

		this.InternalName = internalName;
		this.Name = name;
		this.Description = description;
		this.Section = section;
		this.InputType = inputType;
		this.AllowMultipleValues = allowMultipleValues;

		this.DefinedValues = definedValues;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Attributes.Commands.CreateEmailAttributeCommandV1, TCh.Domain.Alternatives';
	}
}
export class CreateMultilineAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Attributes.Commands.CreateMultilineAttributeCommandV1, TCh.Domain.Alternatives';

	IsCorporate: boolean;

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;

	InternalName: string | null;
	Name: string;
	Description: string;
	Section: string;

	Rows: number;
	MinLength: number | null;
	MaxLength: number | null;

	constructor(isCorporate: boolean, workspaceId: number, projectId: number, alternativesListId: number, attributeId: number, internalName: string | null, name: string, description: string, section: string, rows: number,
		minLength: number | null, maxLength: number | null)
	{
		this.IsCorporate = isCorporate;

		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = attributeId.toString();

		this.InternalName = internalName;
		this.Name = name;
		this.Description = description;
		this.Section = section;

		this.Rows = rows;
		this.MinLength = minLength;
		this.MaxLength = maxLength;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Attributes.Commands.CreateMultilineAttributeCommandV1, TCh.Domain.Alternatives';
	}
}

export class UpdateNumericAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Attributes.Commands.UpdateNumericAttributeCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;

	Name: string;
	Description: string;
	Section: string;
	InputType: string;
	AllowMultipleValues: boolean;

	MinValue: number | null;
	MaxValue: number | null;
	Script: string | null;
	DefinedValues: RealDefinedValue[] | null;

	constructor(workspaceId: number, projectId: number, alternativesListId: number, attributeId: number, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minValue: number | null, maxValue: number | null, script: string | null, definedValues: RealDefinedValue[] | null)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = attributeId.toString();

		this.Name = name;
		this.Description = description;
		this.Section = section;
		this.InputType = inputType;
		this.AllowMultipleValues = allowMultipleValues;

		this.MinValue = minValue;
		this.MaxValue = maxValue;
		this.Script = script;
		this.DefinedValues = definedValues;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Attributes.Commands.UpdateNumericAttributeCommandV1, TCh.Domain.Alternatives';
	}
}
export class UpdateDateAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Attributes.Commands.UpdateDateAttributeCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;

	Name: string;
	Description: string;
	Section: string;
	InputType: string;
	AllowMultipleValues: boolean;

	MinValue: Date | null;
	MaxValue: Date | null;
	DefinedValues: DefinedValue[] | null;

	constructor(workspaceId: number, projectId: number, alternativesListId: number, attributeId: number, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minValue: Date | null, maxValue: Date | null, definedValues: DefinedValue[] | null)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = attributeId.toString();

		this.Name = name;
		this.Description = description;
		this.Section = section;
		this.InputType = inputType;
		this.AllowMultipleValues = allowMultipleValues;

		this.MinValue = minValue;
		this.MaxValue = maxValue;
		this.DefinedValues = definedValues;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Attributes.Commands.UpdateDateAttributeCommandV1, TCh.Domain.Alternatives';
	}
}
export class UpdateTextAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Attributes.Commands.UpdateTextAttributeCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;

	Name: string;
	Description: string;
	Section: string;
	InputType: string;
	AllowMultipleValues: boolean;

	MinLength: number | null;
	MaxLength: number | null;
	DefinedValues: DefinedValue[] | null;

	constructor(workspaceId: number, projectId: number, alternativesListId: number, attributeId: number, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minLength: number | null, maxLength: number | null, definedValues: DefinedValue[] | null)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = attributeId.toString();

		this.Name = name;
		this.Description = description;
		this.Section = section;
		this.InputType = inputType;
		this.AllowMultipleValues = allowMultipleValues;

		this.MinLength = minLength;
		this.MaxLength = maxLength;
		this.DefinedValues = definedValues;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Attributes.Commands.UpdateTextAttributeCommandV1, TCh.Domain.Alternatives';
	}
}
export class UpdateEmailAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Attributes.Commands.UpdateEmailAttributeCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;

	Name: string;
	Description: string;
	Section: string;
	InputType: string;
	AllowMultipleValues: boolean;

	DefinedValues: DefinedValue[] | null;

	constructor(workspaceId: number, projectId: number, alternativesListId: number, attributeId: number, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean, definedValues: DefinedValue[] | null)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = attributeId.toString();

		this.Name = name;
		this.Description = description;
		this.Section = section;
		this.InputType = inputType;
		this.AllowMultipleValues = allowMultipleValues;

		this.DefinedValues = definedValues;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Attributes.Commands.UpdateEmailAttributeCommandV1, TCh.Domain.Alternatives';
	}
}
export class UpdateMultilineAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Attributes.Commands.UpdateMultilineAttributeCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;

	Name: string;
	Description: string;
	Section: string;

	Rows: number;
	MinLength: number | null;
	MaxLength: number | null;

	constructor(workspaceId: number, projectId: number, alternativesListId: number, attributeId: number, name: string, description: string, section: string, rows: number,
		minLength: number | null, maxLength: number | null)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = attributeId.toString();

		this.Name = name;
		this.Description = description;
		this.Section = section;

		this.Rows = rows;
		this.MinLength = minLength;
		this.MaxLength = maxLength;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Attributes.Commands.UpdateMultilineAttributeCommandV1, TCh.Domain.Alternatives';
	}
}



export class DeleteAttributeCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Attributes.Commands.DeleteAttributeCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;

	constructor(workspaceId: number, projectId: number, alternativesListId: number, attributeId: number)
	{
		this.WorkspaceId = workspaceId;
		this.Id = attributeId.toString();
		this.AlternativesListId = alternativesListId;
		this.ProjectId = projectId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Attributes.Commands.DeleteAttributeCommandV1, TCh.Domain.Alternatives';
	}
}
